import { render, staticRenderFns } from "./MemoRandum.vue?vue&type=template&id=251748aa&scoped=true"
import script from "./MemoRandum.vue?vue&type=script&setup=true&lang=js"
export * from "./MemoRandum.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MemoRandum.vue?vue&type=style&index=0&id=251748aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251748aa",
  null
  
)

export default component.exports